import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EmptyStateComponent } from '@tecalisdev/infinity';

/**
 * Comprobaciones específicas BORME: pendiente de contrato de checks en API.
 * Muestra estado vacío coherente con el resto de operaciones.
 */
@Component({
	selector: 'app-operation-detail-tabs-checks-borme',
	imports: [TranslatePipe, EmptyStateComponent],
	templateUrl: './operation-detail-tabs-checks-borme.component.html',
})
export class OperationDetailTabsChecksBormeComponent {}
